import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Helper, getShortDecimalFormat } from '@piqet-angular/data';
import { EN_LOCALE, reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';

@Component({
  selector: 'piqet-angular-report-product-detail',
  templateUrl: './report-product-detail.component.html',
  styleUrls: ['./report-product-detail.component.scss'],
})
export class ReportProductDetailComponent implements OnChanges {
  @Input() impactItems: any;
  @Input() isExportFlag: any;
  @Input() isReportAccess: any;
  @Input() isApiCAll: any = false;
  reportResource = reportTitals;

  constructor(private reportService: ReportsService) {}

  ngOnChanges(changes: SimpleChanges) {
    // need this code
    // if (this.isApiCAll) {
    //   this.getProductDetails()
    // } else {
    //   this.impactItems = changes['impactItems']?.currentValue;
    //   console.log(this.impactItems, "impact")
    // }
  }

  ngOnInit() {
    if (this.isApiCAll) {
      this.getProductDetails();
    }
  }

  async getProductDetails() {
    const response = await this.reportService.getProductDetails(
      this.impactItems.productId,
      this.isExportFlag
    );
    this.impactItems = response.data;
  }

  getComponenttransportationItems(data: any) {
    return data.some((item: any) => {
      return item.componenttransportationItems && item.componenttransportationItems.length > 0;
    });
  }
  getShortDecimalFormat(impactValue: string): string {
    return getShortDecimalFormat(impactValue);
  }
}
